import { Component } from 'react';
import qs from 'qs';
import store, { history } from '../../store';

export default (WrappedComponent, getDataAction) => (
  class extends Component {
    state = {
      query: '',
      pageNumber: 1
    };

    handlePageChange = (page) => {
      this.setState({
        pageNumber: page
      }, this.afterPageChange);
    };

    doSearch = (e) => {
      if (e.key === 'Enter') {
        this.handleSearch();
      }
    };

    afterPageChange = () => {
      const { query, pageNumber } = this.state;
      store.dispatch(getDataAction(query, pageNumber));
      history.push(`${window.location.pathname}?page=${pageNumber}`);
    };

    handleChange = (event) => {
      this.setState({
        query: event.target.value
      });
    };

    handleClear = () => {
      this.setState({
        query: '',
        pageNumber: 1
      });

      this.getData();
    };

    handleSearch = () => {
      this.getData(this.state.query);
    };

    componentDidMount() {
      let pageNumber = 1;

      if (window.location.search) {
        const params = qs.parse(window.location.search.slice(1));
        pageNumber = parseInt(params.page) || 1;

        this.setState({ pageNumber });
      }

      history.push(`${window.location.pathname}?page=${pageNumber}`);
      this.getData('', pageNumber);
    }

    getData(query = '', pageNumber = '') {
      store.dispatch(getDataAction(query, pageNumber))
        .then(() => {
          this.setState({
            pageNumber
          });
        });
    }

    render() {
      return (
        <WrappedComponent
          handlePageChange={this.handlePageChange}
          handleChange={this.handleChange}
          handleClear={this.handleClear}
          handleSearch={this.handleSearch}
          doSearch={this.doSearch}
          getData={this.getData}
          afterPageChange={this.afterPageChange}
          {...this.state}
          {...this.props}
        />
      );
    }
  }
);
